import React from 'react';

import Permission from '../components/Permissions/Permission';
import TeamsList from '../components/Teams/TeamsList';

const Page = {
  PERMISSION: 'permission',
  TEAMS: 'team',
};

function App({
  page = Page.PERMISSION,
  accountId,
  projectId,
  entityType,
  entityId,
  entityKey,
  closeDialog,
  options = {},
}) {
  const enableTeams = !!options.enableTeams;
  console.log(`[INFO] enableTeams: ${enableTeams}`);

  return (
    <div className="App flex flex--1">
      {page === Page.PERMISSION && (
        <Permission
          {...{ accountId, projectId, entityType, entityId, entityKey, closeDialog, enableTeams }}
        />
      )}
      {page === Page.TEAMS && <TeamsList accountId={accountId} />}
    </div>
  );
}

export default App;
